import axios from 'axios'

import { HTTP_TIMEOUTS } from './timeouts'

/**
 * Instância dedicada do axios usada por toda a aplicação.
 *
 * Antes o `AxiosHttpClient` chamava o axios **global** (`axios.get`, `axios.post`...). Qualquer
 * interceptor ou default nosso vazaria para as libs de terceiro que também usam o axios global
 * (`@sentry/react`, `crisp-sdk-web`, `@amplitude/analytics-browser`), o que é inaceitável.
 *
 * ATENÇÃO EM TESTES: `new MockAdapter(axios)` (axios global) **não intercepta** esta instância.
 * Specs que precisam mockar HTTP devem usar `new MockAdapter(httpAgent)`.
 */
export const httpAgent = axios.create({
  /**
   * Default deliberadamente curto.
   *
   * ORDEM IMPORTA: este default só é seguro porque os call sites de dataset (waypoints_full, .frb,
   * .fgb, .geoz, meteorologia, catálogos) já declaram `HTTP_TIMEOUTS.dataset` explicitamente. Ligar
   * o default antes disso abortaria o download dos 25 MB de `waypoints_full` em qualquer conexão
   * lenta — era o risco de regressão nº 1 desta frente.
   */
  timeout: HTTP_TIMEOUTS.interactive
})
